import gql from 'graphql-tag';
import { DEAL_SHEET_CONFIGURATION_FRAGMENT } from './configurationFragment';

export const GET_DEAL_SHEET_GLOBAL_CONFIGURATION = gql`
  query GetDealSheetConfig($input: DealSheetConfigurationInput!) {
    dealSheets {
      result: dealSheetGlobalConfiguration(input: $input) {
        error
        success
        entity {
          ...DealSheetConfig
        }
      }
    }
  }
  ${DEAL_SHEET_CONFIGURATION_FRAGMENT}
`;
